/* Copyright (c) 2022 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum VisualDisplayTypes {
    /* 0 */ OVERLAY = 0,
    /* 1 */ OSD,
    /* 2 */ SPINNER,
}
